import { AutomaticTabActivator } from './AutomaticTabActivator';
import { BaseTabActivator } from './BaseTabActivator';
import { ManualTabActivator } from './ManualTabActivator';
import { TabActivationMode, TabsWidget } from './TabsWidget';

export class TabActivatorFactory {
  public static CreateInstance(tabsWidget: TabsWidget): BaseTabActivator {
    const isActivationModeManual = tabsWidget.props.activationMode === TabActivationMode.Manual;
    return isActivationModeManual ? new ManualTabActivator(tabsWidget) : new AutomaticTabActivator(tabsWidget);
  }
}
